<template>
  <div>
    <!-- 검색 -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td>이미지<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'textbook_id')">참고서 아이디<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'textbook_nm')">참고서명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'author')">저자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'subject_nm')">카테고리<em class="fa-2s mr-2 fas fa-sort"></em></td>

            <td width="120">Action</td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="7">No matching records</td>
          </tr>
          <tr v-for="(item, index) in data.list" :key="index">
            <td>
              <img :src="item.url " style="height:80px">
            </td>
            <td>{{ item.prdSeq }}</td>
            <td>{{ item.prdNm }}</td>
            <td>{{ item.author }}</td>
            <td>{{ item.menuType }}</td>
            <td>
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="detail(item)"><em class="fa fa-search"></em></b-btn>
                <b-button @click="save(item)" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2"><em class="fa fa-cloud-download-alt"></em></b-button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->


    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default">
        <YcloudReperenceBookMstDetail :bookId="data.row.prdSeq"  :data="data" :key="data.row.prdSeq"/>

      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">가져오기</b-button>
          <b-button @click="search()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->
  </div>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getYbmTextbookMstList, getYbmTextbookMstItem, saveYbmTextbookMst, deleteYbmTextbookMst} from "@/api/ext/YbmTextBookMstApi";
import {getLmReferenceBookList,getLmReferenceBookitem} from "@/api/lm/LmReferenceBookApi";
import {getLmTextBookItem} from "@/api/lm/LmTextBookApi";
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,aws_cdn_path} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import YcloudReperenceBookMstDetail from "./components/YcloudReperenceBookMstDetail";
import swal from 'sweetalert2'

export default {
  props: {
    bookId: '',
  },
  components: {SchDateRange, SchText, Pagenation,YcloudReperenceBookMstDetail},
  setup(props, context) {
    const schOptions = [{value: 'textbook_id', text: '참고서 아이디'}, {value: 'textbook_nm', text: '참고서명'}]
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)
    data.schOptions = schOptions // 검색 type 선택
    data.aws_cdn_path = aws_cdn_path

    console.log('## props',props.bookId)
    const loadData = async () => {
      if(props.bookId){  // 상세모달
        data.params.prdSeq = props.bookId
        data.params.mode = 'detail';
        let result = await getLmReferenceBookList(data.params);
        data.row = result.data;
      }else{
        let result = await getLmReferenceBookList(data.params);
        data.list = result.data;
        data.count = result.count;
      }
    }

    onMounted(loadData)

    return {
      data,
      ...methods(props, context),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods(props, context) {
  var apiContext = {};
  apiContext["getYbmTextbookMstList"] = getYbmTextbookMstList;  // get list
  apiContext["getYbmTextbookMstItem"] = getYbmTextbookMstItem;  // get item
  apiContext["getLmReferenceBookList"] = getLmReferenceBookList; // get item
  apiContext["getLmReferenceBookitem"] = getLmReferenceBookitem; // get item
  apiContext["getLmTextBookItem"] = getLmTextBookItem; // get item

  // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getLmReferenceBookList", apiContext, _params);
  }
  // 초기화
  async function reset() {
    this.dataAction.clear();
  }
 async function detail(_item){
    this.data.params.mode = 'detail';
    props.bookId = _item.prdSeq;
    //this.data.params.bookId = _item.textbookId
    let _params = {
      prdSeq : _item.prdSeq,
      mode : 'detail'
    }
    let result = await getLmReferenceBookitem(_params);
    this.data.row = result.data;

    /*let _params = {
      textbookId: _item.bookId
    }
    this.dataAction.execute("getTextbookMstItem",context, _params);*/
  }
  async function save(_item) {
    // 1. 교재정보
    let bookInfo = _item?_item:this.data.row;
    swal({
      title: "Ycloud 참고서 내려받기",
      text: "LMS로 참고서 정보를 복사합니다",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "OK",
      heightAuto: false
    }).then((result) => {
      if(result.value){
        let params = {
            bookSeq: 0,
            bookId: bookInfo.prdSeq,
        }
        saveBookValid(params, bookInfo);
      }
    });
  }

  async function saveBookValid(params,bookInfo){
    let res =  await getLmTextBookItem(params);
    if(res.data){
          swal({
            title: "Ycloud 참고서 내려받기",
            text: "참고서데이터가 이미 존재합니다.",
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "OK",
            heightAuto: false
          })
        } else{
          context.emit('saveYcloudReferenceBook', bookInfo);
        }
  }

  return {reset, search, detail, save, saveBookValid}
}


</script>